"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Sparkline_1 = require("../components/widgets/sparkline/Sparkline");
var LayoutComponents_1 = require("../style/LayoutComponents");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
var SparklineCaption = LayoutComponents_1.divWithStyle('sparkline-caption', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Small,
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
    textAlign: 'right'
});
var sparklineWidth = ViewerPaneStyles_1.dataDetailsContentWidth;
var sparklineHeight = 66;
/**
 * A wrapper around the Sparkline component that adds a caption below.
 */
var SparklineWithCaption = /** @class */ (function (_super) {
    __extends(SparklineWithCaption, _super);
    function SparklineWithCaption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SparklineWithCaption.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Sparkline_1.Sparkline, { width: sparklineWidth, height: sparklineHeight, dataPoints: this.props.dataPoints, title: this.props.caption }),
            React.createElement(SparklineCaption, { style: { width: sparklineWidth } }, this.props.caption)));
    };
    return SparklineWithCaption;
}(React.Component));
exports.SparklineWithCaption = SparklineWithCaption;
//# sourceMappingURL=SparklineWithCaption.js.map